import classNames from 'classnames'
import styles from './FilterBar.module.css'

interface FilterOption<T extends string> {
  value: T
  label: string
}

interface FilterBarProps<T extends string> {
  value: T
  options: FilterOption<T>[]
  onChange: (value: T) => void
  nullable?: boolean
  disabled?: boolean
}

export function FilterBar<T extends string>({ value, options, onChange, nullable, disabled }: FilterBarProps<T>) {
  return (
    <div className={styles['filters']}>
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => !disabled && onChange(nullable && value === opt.value ? ('' as T) : opt.value)}
          className={classNames(styles['filterButton'], value === opt.value && styles['filterButtonActive'])}
          disabled={disabled}
        >
          {opt.label}
        </button>
      ))}
    </div>
  )
}
